export const IntlActionTypes = {
  SET_INTL_OVERRIDES: "SET_INTL_OVERRIDES",
};

class IntlActioner {
  static setIntlOverrides(overrides) {
    return {
      type: IntlActionTypes.SET_INTL_OVERRIDES,
      overrides,
    };
  }
}

export default IntlActioner;
